module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Bar_01.4b5ce5b8.png";